import React, { useContext, useState } from 'react';
import { useQuery, useMutation } from '@apollo/client';
import { DateTime } from 'luxon';

import ClientContext from 'app/src/contexts/ClientContext';
import { Button } from 'app/src/elements/buttons';
import { Notice } from 'app/src/elements/Notice';
import { Text, Warning } from 'app/src/styles';

import {
  DEALER_FEATURE_SUBSCRIPTIONS,
  SETUP_FEATURE_SUBSCRIPTION,
} from './queries';

const isSubscriptionActive = subscription => {
  return (
    !subscription.deletedAt ||
      DateTime.fromISO(subscription.deletedAt) > DateTime.now()
  );
};

const NewFeatureSubscription = ({ dealerId }) => {
  const { currentUser } = useContext(ClientContext);
  const [formStatus, setFormStatus] = useState();

  const { data } = useQuery(DEALER_FEATURE_SUBSCRIPTIONS, {
    variables: { id: dealerId }
  });

  const [setupFeatureSubscription] = useMutation(SETUP_FEATURE_SUBSCRIPTION, {
    onCompleted: data => {
      window.location.href = data.setupFeatureSubscription.sessionUrl;
    }
  });

  const handleSubscribe = () => {
    setFormStatus('Processing');
    setupFeatureSubscription({ variables: { dealerId } });
  };

  if (!data) { return null; }
  if (!currentUser) { return null; }

  const activeFeatureSubscriptions = data.dealer.featureSubscriptions
    .filter(isSubscriptionActive);

  const allComplimentary =
    activeFeatureSubscriptions.length > 0 &&
    activeFeatureSubscriptions.every(
      subscription => subscription.isComplimentary
    );

  // Dealer already has a real (paid) active subscription — nothing to show.
  if (activeFeatureSubscriptions.length > 0 && !allComplimentary) {
    return null;
  }

  if (allComplimentary) {
    return (
      <Notice type="warning">
        {[
          <Text key="complimentary" style={{ fontWeight: 600 }}>
            You currently have a complimentary subscription. To purchase a
            subscription,{' '}
            <Text
              onPress={handleSubscribe}
              style={{ textDecorationLine: 'underline' }}
            >
              click here
            </Text>
            .
          </Text>,
          <Text key="price" style={{ fontWeight: 600 }}>
            The price is $49.00 for 3 months and will auto-renew until
            canceled.
          </Text>,
        ]}
      </Notice>
    );
  }

  const subscriptionRequiredForNonAdrOn =
    DateTime.fromISO(currentUser.subscriptionRequiredForNonAdrOn);

  let notice =
    'To pre-register sales using temporary tags not purchased from ' +
    'ADR or OklahomaTempTag, a subscription is required.';

  if (subscriptionRequiredForNonAdrOn > DateTime.now()) {
    notice =
      'Beginning ' +
      subscriptionRequiredForNonAdrOn.toLocaleString(DateTime.DATE_HUGE) +
      ' a subcription will be required to pre-register temporary tags ' +
      'not purchased from ADR or OklahomaTempTag.';
  }

  return (
    <Warning>
      <Text>{notice}</Text>
      <Text>
        The price is $49.00 for 3 months and will auto-renew until canceled.
      </Text>

      <Button
        label="Click to Subscribe"
        onPress={handleSubscribe}
        processing={'Processing' === formStatus}
      />
    </Warning>
  );
};

export default NewFeatureSubscription;
